<template>
  <Modal
    title="Reason for Making Changes to Communications"
    submit-btn-text="Save Changes"
    :disable-submit="isBlank(reason)"
    @hide-modal="emit('hide-modal')"
    @submit="emit('save', reason)"
    @show-modal="focusInput"
  >
    <label class="full-width">
      *Enter Reason
      <textarea
        ref="input"
        v-model="reason"
        class="form-control full-width"
      ></textarea>
    </label>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { isBlank } from "@/lib/helpers.js";

import Modal from "@/components/Modal.vue";

const input = ref<HTMLElement | null>(null);
const reason = ref("");

const emit = defineEmits(["save", "hide-modal"]);

function focusInput() {
  input.value?.focus();
}
</script>

<style lang="scss" scoped></style>
